import { ObjectManager } from '../../../concepts/objects';
import { KeyInput } from '../../../platform/input/KeyInput';
import { MouseButtons, MouseInput } from '../../../platform/input/MouseInput';
import { resolve } from '../../Container';
import { Concealable, IsActuallyConcealed } from '../../packages/conceal/Concealable';
import { Camera } from '../Camera';
import { EditorSession } from '../EditorSession';
import { Physical } from '../entities/Physical';
import { Selection } from '../Selection';
import { ToolBehavior } from './ToolBehavior';

export class HyperlinkToolBehavior extends ToolBehavior {

    private href: string;

    @resolve(Camera) private camera: Camera;
    @resolve(ObjectManager) private objects: ObjectManager;
    @resolve(EditorSession) private session: EditorSession;

    public getPreferredCursor(state: string) {
        if (state === 'href') {
            return 'pointer';
        }
    }

    public onKeyDown(state: string, e: KeyInput) {
        if (state === 'href' && e.modifiers.any) {
            return 'idle';
        }
    }

    public onMouseMove(state: string, e: MouseInput) {
        if (state !== 'idle' && state !== 'href') return;

        if (!e.modifiers.any) {
            const anchor = this.findApplicableAnchorForMousePosition(e);
            if (anchor) {
                this.href = anchor.getAttribute('href');
                return 'href';
            }
        }

        this.href = null;
        return 'idle';
    }

    public onMouseDown(state: string, e: MouseInput) {
        if (!!this.href && e.button === MouseButtons.Main) {
            window.open(this.href, '_blank');
        }
    }

    private findApplicableAnchorForMousePosition(e: MouseInput) {
        const spt = this.camera.toScreenFromView(e.position);
        const anchor = document
            .elementsFromPoint(spt.x, spt.y)
            .filter(x => (x.nodeName || '').toLowerCase() === 'a')
        [0];

        if (!isOrIsDescendantOf('#canvas', anchor)) return null;

        const ownerId = findAnchorOwnerId(anchor);
        if (!ownerId) return null;

        const owner = this.objects.getMaybe(ownerId, Physical);
        if (!owner) return null;
        if (owner.is(Concealable) && IsActuallyConcealed.get(owner)) return null;

        const selection = this.session.get(Selection);
        if (selection.has(owner)) return null;

        return anchor;
    }
}

const isOrIsDescendantOf = (selector: string, elmt: any) => {
    while (elmt) {
        if (elmt.matches(selector)) return true;
        elmt = elmt.parentElement;
    }
    return false;
};

const findAnchorOwnerId = (elmt: any) => {
    while (!!elmt && !elmt?.id) {
        elmt = elmt.parentElement;
    }
    if (!elmt?.id) return null;
    if (elmt.id.includes('_')) {
        return elmt.id.split('_').filter(x => !!x).join('/');
    }
    return elmt.id;
};
